// Money arrives from the API as a decimal string, which is why this coerces
// rather than requiring a number.
export const formatPrice = (
  price: string | number = 0,
  currency: string = 'GBP'
) => Number(price).toLocaleString(undefined, { style: 'currency', currency });

export const formatDiscount = (discount: number = 0) =>
  discount && Number(discount) > 0
    ? Number(discount / 100).toLocaleString(undefined, {
        style: 'percent',
        maximumFractionDigits: 2,
      })
    : 0;
